/**
 * Parses a floating-point number from a string or number and converts it to an integer
 * after applying a specified number of decimal places and rounding mode.
 *
 * @param value - The value to be parsed and converted. Can be a string or a number.
 * @param decimals - The number of decimal places to consider. Defaults to 2.
 * @param roundingMode - The rounding mode to apply. Can be 'floor', 'round', or 'ceil'. Defaults to 'floor'.
 * @returns The parsed and converted integer, or `undefined` if the input value is not a valid number.
 */
export const parseFloatToInt = (
  value: string | number,
  decimals = 2,
  roundingMode: 'floor' | 'round' | 'ceil' = 'floor',
) => {
  const number = Number.parseFloat(String(value));
  if (Number.isNaN(number)) return undefined;

  const multiplier = 10 ** decimals;
  const result = number * multiplier;

  return Math[roundingMode](result);
};
